<div class="row">

	<div class="col-xl-12 col-md-12 col-sm-12">
		<div class="kt-portlet kt-portlet--height-fluid">

			<div class="kt-portlet__body">
				<mat-tab-group class="approveTabGroup" (selectedTabChange)="onTabChanged($event)" [selectedIndex]="selectedIndex">


						<mat-tab label="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.TITLE' | localize }}" *ngIf="pendingRequestsAuthorization">
							<div *ngIf="tabIndex == 1">
								<kt-requests-pending-my-approval></kt-requests-pending-my-approval>

							</div>
						</mat-tab>
					<mat-tab label="{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.TITLE' | localize }}" *ngIf="isMyRequestAuth">

						<div *ngIf="tabIndex == 2">
							<kt-my-pending-requests></kt-my-pending-requests>

						</div>
					</mat-tab>


					<mat-tab label="{{ 'FE.APPROVALS.TABS.PASTORDERS.TITLE' | localize }}">
						<div *ngIf="tabIndex == 3">
							<kt-my-past-requests></kt-my-past-requests>
						</div>
					</mat-tab>

				</mat-tab-group>
			</div>
		</div>
	</div>
</div>



			



